import { Injectable } from '@angular/core';
import { UserInformation, UsersAndUniversityDepartments } from '../models/user-information.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { observe } from '../../../shared/utils/functions/observe.function';
import { IResponse } from '../../../shared/data-access/models/response.models';
import { Faculty } from '../models/faculties-model';
import { IUni } from '../models/universityUsers-model';
import { FormGroup } from '@angular/forms';
import { UniversityData } from '../../../shared/data-access/models/universityProfiles.model';

@Injectable({
  providedIn: 'root'
})
export class HodAccountsService {
  private applicationsSubject: BehaviorSubject<UserInformation[]> = new BehaviorSubject<UserInformation[]>([

  ]);

  constructor(private http: HttpClient) {}

  getAccounts(): Observable<IResponse<UsersAndUniversityDepartments>>  {

    return observe(this.http.get<UsersAndUniversityDepartments>(`api/users`),);
  }
  editAccount(id:string,updatedAccount: Partial<UserInformation>, originalAccount: UserInformation, profile: string): Observable<IResponse<{success: boolean}>> {
    const body={
      oid:id, customAttributes:updatedAccount, applicationGuidDetailsForm:originalAccount, updatedProfile:profile
     }
    return observe(this.http.patch<{success: boolean}>(`api/user/`, body));
  }

  deleteAccount(id: string,emailAddress:string): Observable<IResponse<{ success: boolean }>> {
    return observe(this.http.put<{ success: boolean }>(`api/deleteUser/?id=${id}&&email=${emailAddress}`, {}));
  }
  inviteUniversityStaff(invitationForm: {data: FormGroup}) {

    const url = `api/invite-university-staff/`;
    return observe(this.http.post(url, invitationForm));
  }

  addUniversity(university: string, faculty: String): Observable<IResponse<any>> {
    const body = {
      university: university,
      faculty: faculty
    }
    return observe(this.http.post<UserInformation>(`api/addUniversity`, body));
  }
  getFaculties(): Observable<IResponse<Faculty[]>> {
   return observe(this.http.get<Faculty[]>(`api/faculties`));
  }
  addDepartment(addDepartmentObject: {
    university: string,
    department: string,
    faculty: string,
    newFaculty: string,
  }): Observable<IResponse<any>> {

   return observe(this.http.post(`api/addDepartment`, addDepartmentObject));
  }
  getDepartmentsAndUniversity():Observable<IResponse<any>> {
    return observe(this.http.get<IUni[]>(`api/getDepartmentsAndUniversity`));
  }
  getDepartments(universityName:string="",facultyName:string=""):Observable<IResponse<any>> {
    return observe(this.http.get<any>(`api/universityDepartments?universityName=${universityName}&facultyName=${facultyName}`));
  }

  getDepartmentsAllocations(universityName:string,facultyName:string,year:number):Observable<IResponse<any>> {
    return observe(this.http.get<any>(`api/universityDepartmentsAmount?universityName=${universityName}&facultyName=${facultyName}&year=${year}`));
  }

  getIndividualUniversityDepartmentsStatus(universityName:string):Observable<IResponse<UniversityData>> {
    return observe(this.http.get<any>(`api/universityStatus/?universityName=${universityName}`));
  }
}
